import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import i18n, {
  LANGUAGE_NAMES,
  SUPPORTED_LANGUAGES,
  type Language,
} from "@/lib/i18n";
import { useT } from "@/lib/translation";
import { cn } from "@/lib/utils";

interface LanguageMenuProps {
  onSelect: (language: Language) => void;
  triggerClassName?: string;
}

/** Globe dropdown (EN / PT) used by the marketing header and the app top bar. */
export function LanguageMenu({
  onSelect,
  triggerClassName,
}: LanguageMenuProps) {
  // useT re-renders this component on language change, so i18n.language stays current.
  const t = useT();
  const current = i18n.language;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            "flex items-center gap-1 text-sm rounded-xl outline-none hover:bg-muted/60",
            triggerClassName,
          )}
          aria-label={t("nav:marketing.language")}
          title={t("nav:marketing.language")}
        >
          <Globe className="h-4 w-4 opacity-70" />
          {current === "pt-PT" ? "PT" : "EN"}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[8rem]">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onSelect={() => onSelect(lang)}
            className={lang === current ? "font-medium" : ""}
          >
            {LANGUAGE_NAMES[lang]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
